<template>
    <div class="guide-box" v-show="showGuide">
        <template v-for="(item, index) in 4" :key="index">
            <div class="img" @click="next(index+1)" v-show="index === currentIndex"><img :src="`https://kwdyhomeimg.dyhome.com/images/${index+1}.jpg`" alt=""></div>
        </template>
    </div>
</template>

<script>
import { ref } from 'vue'
import Cookies from 'js-cookie'
export default{
    setup(){
        const currentIndex = ref(0)
        const showGuide = ref(!Cookies.get('guide'))
        
        const next = (index) => {
            currentIndex.value = index;
            Cookies.set('guide', true)

            if(index == 4) {
                showGuide.value = false;
            }
        }

        return {
            currentIndex,
            showGuide,
            next
        }
    }
}
</script>

<style lang="less" scoped>
.guide-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: @headZindex + 2;
    background-color: rgba(0, 0, 0, 0.5);
    .img {
        width: 100%;
        height: 100%;
    }
    img {
        width: 100%;
        display: block;
        height: 100%;
    }
}
</style>